import type { AddTrialExtendBody } from '../types';

export const AddFreeService = Symbol.for('AddFreeService');

/**
 * Add Trial Service
 * 管理产品准入决策与试用权限赋权流程
 */
export interface AddFreeService {
    /**
     * 执行产品准入检查并分发后续动作
     *
     * 调用后端 `product-onboarding/check` 接口，根据返回的 action_type 决策：
     * 直接进入产品 / 清缓存刷新（后端已赋权）/ 跳转 account-status 落地页。
     *
     * @param grantedProductIds - 已授权的产品ID列表
     */
    addFreePkg(grantedProductIds: string[]): Promise<void>;

    /**
     * 获取赋权权限类型
     *
     * 当前固定返回 'AIR'，复用 AIR 赋权链路。
     * @returns 权限类型 ('AIR' | 'LS' | 'INSIGHTS')
     */
    getEmpowerType(): string;

    /**
     * 检查当前是否启用自动添加试用
     */
    isAutoAddTrialEnabled(): boolean;
}
